export const STORAGE_KEY = {
  ACCESS_TOKEN: 'accessToken',
  CTI_ACCESS_TOKEN: 'ctiAccessToken',
  CTI_USER_ID: 'ctiUserId',
  DARK_MODE: 'darkMode',
  UNIQUE_IDENTIFIER: 'uniqueIdentifier',
  CHECKOUT_SESSION_ID: 'checkoutSessionId',
  UNITY_USER: 'unityUser',
  AUDIENCE_CONTACTS_PAGE_SIZE: 'audienceContactsPageSize',
  INITIAL_CHAT_MESSAGE: 'initialChatMessage',
  INITIAL_CHAT_CONTEXT: 'initialChatContext',
};

export const chatHandoffStorageKey = (key: string, handoffToken: string) => (
  `${key}:${handoffToken}`
);
